import { useLocation } from "react-router-dom";
import { WaltzData } from "../../../interface/glassCategory.interface";
import InnerBannerWrapper from "./innerBannerWrapper";

function WaltzPDF() {
  const waltzData: WaltzData = {
    "slide": {
      title: "WALTZ SLIDE NXT",
      path: "/assets/pdfs/SlideNXT.pdf"
    },
    "glide": {
      title: "WALTZ GLIDE NXT",
      path: "/assets/pdfs/GlideNXT.pdf"
    },
    "swing": {
      title: "WALTZ SWING",
      path: "/assets/pdfs/SwingNXT.pdf"
    },
    "close": {
      title: "WALTZ CLOSE NXT",
      path: "/assets/pdfs/CloseNXT.pdf"
    },
    "wardrobe": {
      title: "WARDROBE",
      path: "/assets/pdfs/wardrobe-catalogue.pdf"
    },

  }
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const data: string = params.get('title') || "";
  const title: string = data in waltzData ? waltzData[data as keyof WaltzData].title : "";
  const path: string = data in waltzData ? waltzData[data as keyof WaltzData].path : "";

  return (
    <>
      <InnerBannerWrapper />

      <section className="cataloguesInner py-100">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-12 text-center mb-5">
              <h2 className="titleMain">DOWNLOAD CATALOGUES</h2>
              <p className="txt-gray">
                View or download the catalogues that help you open the world of
                sophistication, and discover the perfect engineering to make
                your vision a reality.
              </p>
            </div>
            <div className="col-lg-10 col-md-10 col-sm-12 col-12">
              <div className="row d-flex justify-content-center">
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className="cataloguesDownImg">
                    <div className="jbLogoHldr">
                      <img src="assets/images/logo.webp" alt=" " />
                    </div>
                    <div className="pdfImgTitleHldr">
                      <div className="pdfImgHldr">
                        <img src="assets/images/pdf-img.webp" alt=" " />
                      </div>
                      <div className="pdfTitle">{title}</div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center">
                  <div className="cataDownTxtHldr">
                    <h2>{title}</h2>
                    <div className="d-flex mt-4">
                      <a
                        href={path}
                        className="btn btn-black-border1"
                        target="_blank" rel="noreferrer"
                      >
                        Download
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default WaltzPDF;
